import { useCallback } from 'react';
import { useAnalytics } from '../../context/analytics';
import { useWelcomeContext } from './WelcomeContext';

/**
 * CTA click tracking for completion screens. Every completion step (and the classic
 * Done screen) calls this so engagement compares across endings in Amplitude. No-ops
 * in the admin preview modal and before the session loads.
 */
export function useDoneCta(stepCode: string = 'DONE') {
  const { session, isPreview } = useWelcomeContext();
  const { amplitude } = useAnalytics();

  return useCallback(
    (destination: 'community' | 'profile' | 'review' | 'critique_post' | 'continue') => {
      if (isPreview || !session) return;
      amplitude.track('onboarding_done_cta_clicked', {
        destination,
        step_code: stepCode,
        flow_version_id: session.flowVersion.id,
        flow_version_number: session.flowVersion.version,
        flow_version_name: session.flowVersion.name,
      });
    },
    [amplitude, session, isPreview, stepCode]
  );
}
